/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Export_ActionInputs */

const en_us2_history_transfer_export_action = /** @type {(inputs: History_Transfer_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export CSV`)
};

const pt_br2_history_transfer_export_action = /** @type {(inputs: History_Transfer_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar CSV`)
};

const es_419_history_transfer_export_action = /** @type {(inputs: History_Transfer_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar CSV`)
};

const pt_pt2_history_transfer_export_action = /** @type {(inputs: History_Transfer_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar CSV`)
};

const fr_fr2_history_transfer_export_action = /** @type {(inputs: History_Transfer_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter en CSV`)
};

const de_de2_history_transfer_export_action = /** @type {(inputs: History_Transfer_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV exportieren`)
};

const it_it2_history_transfer_export_action = /** @type {(inputs: History_Transfer_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta CSV`)
};

/**
* | output |
* | --- |
* | "Export CSV" |
*
* @param {History_Transfer_Export_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_export_action = /** @type {((inputs?: History_Transfer_Export_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Export_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_export_action(inputs)
	if (locale === "es-419") return es_419_history_transfer_export_action(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_export_action(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_export_action(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_export_action(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_export_action(inputs)
	return en_us2_history_transfer_export_action(inputs)
});
export { history_transfer_export_action as "history-transfer.export_action" }